export const validateSequentialStartTime = (input: {
    currentStartMinutes: number | null;
    prevStartMinutes: number | null;
    prevDurationMinutes: number | null;
}): true | string => {
    const { currentStartMinutes, prevStartMinutes, prevDurationMinutes } =
        input;

    if (
        currentStartMinutes === null ||
        prevStartMinutes === null ||
        prevDurationMinutes === null
    ) {
        return true;
    }

    return currentStartMinutes >= prevStartMinutes + prevDurationMinutes
        ? true
        : 'Start time must be at or after the previous product ends';
};
